'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enoughTimeHasPassedForNewAutomatedChatMessage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _lastMessage = require('conversations-schema/thread-history/operators/lastMessage');

var _ThreadHistoryConstants = require('conversations-schema/thread-history/constants/ThreadHistoryConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enoughTimeHasPassedForNewAutomatedChatMessage = exports.enoughTimeHasPassedForNewAutomatedChatMessage = function enoughTimeHasPassedForNewAutomatedChatMessage(threadHistory) {
  if (!threadHistory) {
    return false;
  }

  var latestMessageTimestamp = (0, _pipe2.default)(_lastMessage.lastMessage, _commonMessageFormatGetters.getTimestamp)(threadHistory);

  return Date.now() - latestMessageTimestamp >= _ThreadHistoryConstants.SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS;
};